module.exports = __webpack_public_path__ + "static/media/earn.5b95f51c.png";